import { cn } from '@/lib/utils'

/** Compact accent-colored category button (counter + server menu). */
export function CategoryChip({
  name,
  count,
  accent,
  selected,
  onClick,
  categoryId,
}: {
  name: string
  count?: number
  accent: string
  selected: boolean
  onClick: () => void
  categoryId: string
}) {
  return (
    <button
      type="button"
      data-category-id={categoryId}
      aria-pressed={selected}
      onClick={onClick}
      className={cn(
        'relative flex h-10 shrink-0 select-none items-center gap-1.5 overflow-hidden whitespace-nowrap rounded-md border pl-4 pr-3 transition active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        selected ? 'text-white' : 'text-foreground',
      )}
      style={
        selected
          ? {
              background: `color-mix(in srgb, ${accent} 85%, black)`,
              borderColor: 'transparent',
            }
          : {
              background: `color-mix(in srgb, ${accent} 12%, var(--card))`,
              borderColor: `color-mix(in srgb, ${accent} 40%, transparent)`,
            }
      }
    >
      <span
        aria-hidden
        className="absolute inset-y-0 left-0 w-1"
        style={{ background: selected ? 'rgba(255,255,255,0.45)' : accent }}
      />
      <span className="text-sm font-semibold leading-none">{name}</span>
      {typeof count === 'number' && (
        <span
          className={cn(
            'text-xs tabular-nums leading-none',
            selected ? 'text-white/80' : 'text-muted-foreground',
          )}
        >
          {count}
        </span>
      )}
    </button>
  )
}
